import React, { useState } from 'react';

import styles from '../../assets/styles/AppHome/Sidebar.module.scss';
import Logo from '../../assets/img/Mima-light-logo.png';
import { useNavigate } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import { userStore } from '../../stores';
import { FaBars } from 'react-icons/fa';
import { observer } from 'mobx-react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';

const Sidebar = ({ menuClicked }) => {
	const { user } = userStore;
	const userPermissions = new Set(
		user?.permissions?.map(perm => perm.module) || []
	);
	const permissionArray = Array.from(userPermissions)
	const [expandedNav, setExpandedNav] = useState(-1);

	const navigate = useNavigate();

	return (

		<div className={styles.sb}>
			<div
				className={styles.sb_title}
			>
				<FaBars
					className={styles.sb_icon}
					onClick={menuClicked}
				/>
				<img
					src={Logo}
					className={styles.sb_logo}
					alt="Mima logo"
				/>
			</div>
			<nav className={styles.sb_nav}>
				<ul
					className={styles.sb_nav_ul}
				>
					{SidebarData.filter((x) => {
						return permissionArray.includes(x.module) || x.module === undefined
					}).map((item, index) => {
						return (
							<li
								key={index}
								className={`${styles.sb_nav_item} ${window.location.pathname === item.link
									? styles.sb_nav_item_active
									: ''
									}`}
								onClick={() => {
									if (item.subNav !== undefined) {
										if (expandedNav === index) {
											setExpandedNav(-1);
										} else {
											setExpandedNav(index);
										}
									} else {
										menuClicked();
										navigate(item.link);
									};
								}}
							>
								{(!item.module) || userPermissions.has(item.module) || (item.type === 'GENERAL') ? (
									<>
										<div className={styles.sb_nav_link_group}>
											<div className={styles.sb_nav_link} key={item.title}>
												<span className={styles.sb_nav_link_icon}>
													{item.icon}
												</span>
												<span>
													{item.title}
												</span>

											</div>

											{item.subNav !== undefined && <MdOutlineKeyboardArrowDown className={expandedNav === index ? styles.sb_nav_link_arr : styles.sb_nav_link_arr_1} />}
										</div>
										{expandedNav === index && item.subNav !== undefined && (
											<ul className={styles.subNav_ul}>

												{item.subNav.map((x, i) => (
													<li
														className={`${styles.subNav_li} ${window.location.pathname === x.link
															? styles.subNav_li_active
															: ''
															}`}
														key={i}
														onClick={() => {
															setExpandedNav(-1);
															menuClicked();
															navigate(x.link);
														}}
													>
														<div className={styles.sb_nav_link} key={item.title}>
															<span className={styles.sb_nav_link_icon}>
																{x.icon}
															</span>
															<span>
																{x.title}
															</span>

														</div>
													</li>
												))}

											</ul>
										)}


									</>



								) : (
									''
								)}
							</li>
						);
					})}
				</ul>
			</nav>
		</div>

	);
};

export default observer(Sidebar);
